import getPageType, { PageType, PageTypeOptions } from '@spa/lib/tracking/getPageType';
import pushToDataLayer, { AdditionalData, PushEventType, TrackingEvent } from './pushToDataLayer';
import { LinkParam } from '../react/hooks/useLinkAttributes';

export enum PromotionEvent {
  SELECT = 'select_promotion',
  VIEW = 'view_promotion'
}

enum TrackingParamKey {
  ITM_CAMPAIGN = 'itm_campaign',
  ITM_CONTENT = 'itm_content',
  ITM_MEDIUM = 'itm_medium',
  ITM_POSITION = 'itm_position'
}

export const trackingParamKeys: ReadonlyArray<string> = Object.values(TrackingParamKey);

const convertLinkParamsToPromotionAdditionalData = (
  linkParams: ReadonlyArray<LinkParam>,
  pageTypeOptions: PageTypeOptions
): AdditionalData => {
  const getValueFromLinkParams = (searchedKey: string): string | null => {
    return linkParams.find(({ key }) => key === searchedKey)?.value ?? null;
  };

  const creative_slot = getValueFromLinkParams(TrackingParamKey.ITM_POSITION);
  const promotion_name = getValueFromLinkParams(TrackingParamKey.ITM_CAMPAIGN);
  const pageType: PageType = getPageType(pageTypeOptions);

  return {
    creative_name: getValueFromLinkParams(TrackingParamKey.ITM_MEDIUM),
    creative_slot,
    page_type: pageType,
    promotion_id: `${getValueFromLinkParams(TrackingParamKey.ITM_CONTENT)}_${creative_slot}_${promotion_name}`,
    promotion_name
  };
};

const trackPromotionActions = (
  event: PromotionEvent,
  anonymousId: string | null,
  authenticatedId: string | null,
  linkParams: ReadonlyArray<LinkParam>,
  pageTypeOptions: PageTypeOptions
): void => {
  const ecommerceEvent: PushEventType = {
    anonymousId,
    authenticatedId,
    ecommerce: convertLinkParamsToPromotionAdditionalData(linkParams, pageTypeOptions),
    event,
    type: TrackingEvent.ECOMMERCE
  };

  pushToDataLayer(ecommerceEvent);
};

export default trackPromotionActions;
